import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";

const API = "https://pokeapi.co/api/v2";

export const fetchPokemons = async (limit, offset) => {
  const response = await axios.get(`${API}/pokemon?limit=${limit}&offset=${offset}`);
  
  const pokemons = await Promise.all(
    response.data.results.map(async (pokemon) => {
      try {
        const id = pokemon.url.split("/").slice(-2)[0];
        const pokemonData = (await axios.get(`${API}/pokemon/${id}`)).data;
        
        const sizeData = { height: pokemonData.height, weight: pokemonData.weight };
        const statData = pokemonData.stats.map(stat => ({
          name: stat.stat.name, 
          base_stat: stat.base_stat
        }));
        const backImage = pokemonData.sprites.back_default;
        const image = pokemonData.sprites.front_default;

        // 한국어 이름 가져오기
        const koreanNameObj = (await axios.get(`${API}/pokemon-species/${id}`)).data.names.find(
          (name) => name.language.name === "ko"
        );
        const koreanName = koreanNameObj ? koreanNameObj.name : "No Korean name";

        // 타입 가져오기
        let typeNames = [];
        if (pokemonData.types && pokemonData.types.length > 0) {
          typeNames = await Promise.all(
            pokemonData.types.map(async (typeData) => {
              try {
                const typeResponse = await axios.get(typeData.type.url);
                const koType = typeResponse.data.names.find(name => name.language.name === 'ko');
                return { koreanName: koType.name };
              } catch (error) {
                console.error(`타입 데이터 가져오기 실패: ${error}`);
                return { englishName: typeData.type.name, koreanName: "알 수 없음" };
              }
            })
          );
        }

        // 능력(ability) 가져오기
        let ability = [];
        if (pokemonData.abilities && pokemonData.abilities.length > 0) {
          ability = await Promise.all(
            pokemonData.abilities.map(async (abilityData) => {
              try {
                const abilityResponse = await axios.get(abilityData.ability.url);
                const koAbility = abilityResponse.data.names.find(name => name.language.name === 'ko');
                const koAbilityEffect = abilityResponse.data.flavor_text_entries.find(entry => entry.language.name === 'ko');
                const abilityName = koAbility ? koAbility.name : "알 수 없음";
                const abilityEffect = koAbilityEffect ? koAbilityEffect.flavor_text : "설명 없음";
                return { name: abilityName, effect: abilityEffect };
              } catch (error) {
                console.error(`능력 데이터 가져오기 실패: ${error}`);
                return { name: "알 수 없음", effect: "설명 없음" };
              }
            })
          );
        }

        return { 
          id, 
          name: koreanName, 
          image, 
          backImage, 
          types: typeNames, 
          size: sizeData, 
          stats: statData, 
          abilities: ability // 능력 추가
        };

      } catch (error) {
        console.error(`포켓몬 데이터 가져오기 실패: ${error}`);
        return { id: null, name: "데이터 없음", image: null, types: [], size: null, stats: [], abilities: [] };
      }
    })
  );
  return pokemons;
};




export const useGetPokemons = () => {
  return useInfiniteQuery({
    queryKey: ['pokemon'],
    queryFn: ({ pageParam = 0 }) => fetchPokemons(20, pageParam * 20),
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length < 20) {
        return undefined;
      }
      return pages.length;
    },
    initialPageParam: 0,
  });
};